export const fontAvenirNext = "Avenir Next";
export const fontClearSans = "Clear Sans";
export const fontOpenSans = "Open Sans";
export const familyBody = "Open Sans, Clear Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const familyBrand = "Avenir Next, Helvetica Neue, Helvetica, Arial, sans-serif";
export const styleNormal = "normal";
export const styleItalic = "italic";
export const size100 = "10px";
export const size200 = "12px";
export const size300 = "14px";
export const size400 = "16px";
export const size500 = "18px";
export const size600 = "20px";
export const size700 = "22px";
export const size800 = "24px";
export const size850 = "32px";
export const size900 = "40px";
export const height100 = "15px";
export const height200 = "18px";
export const height300 = "21px";
export const height400 = "24px";
export const height500 = "27px";
export const height600 = "30px";
export const height700 = "33px";
export const height800 = "36px";
export const height850 = "48px";
export const height900 = "60px";
export const weight100 = 100;
export const weight300 = 300;
export const weight400 = 400;
export const weight500 = 500;
export const weight600 = 600;
export const weight700 = 700;
export const heading200Family = "Avenir Next, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading200Size = "16px";
export const heading200Height = "24px";
export const heading200Weight = 600;
export const heading200Color = "#0d1a4c";
export const heading300Family = "Avenir Next, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading300Size = "18px";
export const heading300Height = "27px";
export const heading300Weight = 600;
export const heading300Color = "#0d1a4c";
export const heading400Family = "Avenir Next, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading400Size = "20px";
export const heading400Height = "30px";
export const heading400Weight = 600;
export const heading400Color = "#0d1a4c";
export const heading500Family = "Avenir Next, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading500Size = "22px";
export const heading500Height = "33px";
export const heading500Weight = 600;
export const heading500Color = "#0d1a4c";
export const heading600Family = "Avenir Next, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading600Size = "24px";
export const heading600Height = "36px";
export const heading600Weight = 600;
export const heading600Color = "#0d1a4c";
export const heading650Family = "Avenir Next, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading650Size = "32px";
export const heading650Height = "48px";
export const heading650Weight = 600;
export const heading650Color = "#0d1a4c";
export const heading700Family = "Avenir Next, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading700Size = "40px";
export const heading700Height = "60px";
export const heading700Weight = 600;
export const heading700Color = "#0d1a4c";
export const body200Family = "Open Sans, Clear Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const body200Size = "10px";
export const body200Height = "15px";
export const body200Weight = 400;
export const body200Style = "normal";
export const body200Color = "#333333";
export const body300Family = "Open Sans, Clear Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const body300Size = "12px";
export const body300Height = "18px";
export const body300Weight = 400;
export const body300Style = "normal";
export const body300Color = "#333333";
export const body400Family = "Open Sans, Clear Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const body400Size = "14px";
export const body400Height = "21px";
export const body400Weight = 400;
export const body400Style = "normal";
export const body400Color = "#333333";
export const body500Family = "Open Sans, Clear Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const body500Size = "16px";
export const body500Height = "24px";
export const body500Weight = 400;
export const body500Style = "normal";
export const body500Color = "#333333";
export const body600Family = "Open Sans, Clear Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const body600Size = "18px";
export const body600Height = "27px";
export const body600Weight = 400;
export const body600Style = "normal";
export const body600Color = "#333333";
export const bodyBoldWeight = 700;
export const bodyItalicStyle = "italic";